export const TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_REQUEST =
  'APP/TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_REQUEST';
export const TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_SUCCESS =
  'APP/TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_SUCCESS';
export const TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_FAIL =
  'APP/TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_FAIL';

export function tradeAgreementsSellOutValidatorsCatalogRequest(payload) {
  return {
    type: TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_REQUEST,
    payload: payload,
  };
}

export function tradeAgreementsSellOutValidatorsCatalogSuccess(payload) {
  return {
    type: TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_SUCCESS,
    payload: payload,
  };
}

export function tradeAgreementsSellOutValidatorsCatalogFail(payload) {
  return {
    type: TRADE_AGREEMENTS_SELLOUT_VALIDATORS_CATALOG_FAIL,
    payload: payload,
  };
}
